// utils/dateUtils.ts
export const formatActivityDate = (dateString: string): string => {
  if (!dateString) {
    return "";
  }

  // Fix timezone format from +0530 → +05:30
  const normalized = dateString.replace(/([+-]\d{2})(\d{2})$/, "$1:$2");

  const date = new Date(normalized);
  if (isNaN(date.getTime())) {
    return dateString;
  }

  // Format as YYYY-MM-DD HH:mm:ss
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
